var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "stock-source-controls" },
    [
      _vm.sourceList.length > 1
        ? _c(
            "div",
            {
              staticClass: "stock-source-controls__tabs",
              attrs: { role: "tablist" },
            },
            _vm._l(_vm.sourceList, function (source, index) {
              return _c(
                "button",
                {
                  key: source.value,
                  staticClass: "stock-source-controls__tab",
                  class: { active: index === _vm.activeIndex },
                  attrs: {
                    type: "button",
                    role: "tab",
                    "aria-selected":
                      index === _vm.activeIndex ? "true" : "false",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.selectSource(index)
                    },
                  },
                },
                [_vm._v("\n      " + _vm._s(source.label) + "\n    ")]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.supportsTags
        ? _c("b-form-tags", {
            staticClass: "stock-source-controls__tags",
            attrs: {
              "remove-on-delete": "",
              "no-outer-focus": "",
              "input-attrs": { list: _vm.tagListId },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({
                    tags: selectedTags,
                    inputAttrs,
                    inputHandlers,
                    removeTag,
                    addTag,
                    disableAddButton,
                  }) {
                    return [
                      _vm._l(selectedTags, function (tag) {
                        return _c(
                          "b-form-tag",
                          {
                            key: tag,
                            staticClass: "stock-source-controls__tag",
                            attrs: { variant: "secondary" },
                            on: {
                              remove: function ($event) {
                                return removeTag(tag)
                              },
                            },
                          },
                          [_vm._v("\n        " + _vm._s(tag) + "\n      ")]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "stock-source-controls__tags-field" },
                        [
                          _c(
                            "input",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass:
                                    "stock-source-controls__tags-input",
                                  attrs: {
                                    placeholder: "Filter by tags",
                                    "aria-label": "Filter stock images by tag",
                                  },
                                },
                                "input",
                                inputAttrs,
                                false
                              ),
                              inputHandlers
                            )
                          ),
                          _vm._v(" "),
                          !disableAddButton
                            ? _c(
                                "b-button",
                                {
                                  staticClass:
                                    "stock-source-controls__tags-add",
                                  attrs: {
                                    size: "sm",
                                    variant: "outline-secondary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return addTag()
                                    },
                                  },
                                },
                                [_vm._v("\n          Add\n        ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              342484512
            ),
            model: {
              value: _vm.tags,
              callback: function ($$v) {
                _vm.tags = $$v
              },
              expression: "tags",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "datalist",
        { attrs: { id: _vm.tagListId } },
        _vm._l(_vm.availableTags, function (tag) {
          return _c("option", { key: tag, domProps: { value: tag } })
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }